const getDefaultState = () => ({
  item: null,
  isLoading: false,
});

export const state = () => getDefaultState();

export const actions = {
  CLEAR_DATA({ commit }) {
    commit('CLEAR_DATA');
  },
  async GET_ITEM({ commit }, slug) {
    try {
      commit('SET_IS_LOADING', true);
      const { data } = await this.$axios.$get(`/api/feature-flags/${slug}`);
      commit('SET_ITEM', data);
    } finally {
      commit('SET_IS_LOADING', false);
    }
  },
};

export const mutations = {
  SET_IS_LOADING(state, data) {
    state.isLoading = data;
  },
  SET_ITEM(state, data) {
    state.item = data;
  },
  CLEAR_DATA(state) {
    Object.assign(state, getDefaultState());
  },
};

export const getters = {};
